import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IAnswerEnglishIqV2Request } from './answer-english-iq-v2-request';
import type { IAnswerEnglishIqV2Response } from './answer-english-iq-v2-response';
import { answerEnglishIqV2ResponseSchema } from './answer-english-iq-v2-response';

export async function answerEnglishIqV2Api(
  body: IAnswerEnglishIqV2Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IAnswerEnglishIqV2Response>> {
  return postRequest<IAnswerEnglishIqV2Response>({
    body,
    options,
    path: '/english-iq/answer/v2',
    schema: answerEnglishIqV2ResponseSchema,
  });
}
